import { Observable } from 'rxjs';
import { replace } from 'connected-react-router/immutable';
import _ from 'lodash';

import AuthApi from 'entities/auth/api';

import { LOGIN } from './constants';
import { loginSuccessAction, loginFailedAction } from './actions';

const login = (action$) =>
  action$.ofType(LOGIN).mergeMap(({ email, password }) => {
    const params = _.fromPairs(
      _.compact(
        _.map(
          window.location.search.slice(1).split('&'),
          (parameter) => parameter && parameter.split('=')
        )
      )
    );
    return AuthApi.authLocal(email, password)
      .mergeMap((action) => [
        action,
        replace(params.d ? decodeURIComponent(params.d) : '/'),
        loginSuccessAction(),
      ])
      .catch((e) => Observable.of(loginFailedAction(e, email)));
  });

export default [login];
